const initializeCreatePlanListener = () => {
    const $minicartContainer = $(".js-minicart");
    const isOnPlanChangeFlow = $minicartContainer.data("on-change-plan-flow");

    if (isOnPlanChangeFlow) {
        $(document).on("click", ".js-create-plan-btn, a[href$='monte-seu-pacote']", (e) => {
            e.preventDefault();

            const $clickedBtn = $(e.target);

            $clickedBtn.addClass("btn-primary-loading");

            if (document.activeElement instanceof HTMLElement) {
                document.activeElement.blur();
            }

            const $planConflictModal = $(".js-plan-conflict-modal");

            $planConflictModal.find(".js-plan-conflict-submit").attr("is-add-product", false);
            $planConflictModal.toggleClass("show", true);

            $clickedBtn.removeClass("btn-primary-loading");
        });
    }
};

const initializePlanConflictListeners = () => {
    initializeCreatePlanListener();
};

export default initializePlanConflictListeners;
